/** Human-readable website used in brand kits and rendered post signatures. */
export function cleanBrandKitWebsite(website: string): string {
  return website.trim().replace(/^(?:https?:)?\/\//i, "").replace(/^www\./i, "").replace(/\/+$/, "");
}
